import React from 'react'
// import clsx from 'clsx';
import { Typography, Row, Col } from 'antd'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
const { Title, Paragraph } = Typography

// Set background for slat
const container = css`
  width: 100%;
  padding: 50px;

  @media (max-width: 768px) {
    padding: 30px;
  }

  svg {
    fill: #006;
  }
`
const title = css`
  text-align: center;
`

const row = css`
  // max-width: 980px;
  text-align: center; //applies to title and paragraphs
`

const col = css`
  padding-left: 10px;
  padding-right: 10px;
`

const Container = styled('div')`
  max-width: 980px;
  margin: auto;
`

const benefit = css`
  white-space: no-wrap;
  font-size: 20px !important;
`

const detail = css`
  font-size: 16px !important;
  max-width: 240px;
  margin: auto;
`

const icon = css`
  width: 75px;
  height: 75px;
  margin: auto;
`

const Benefits = () => {
  return (
    <div css={container} className="sf-reverse-gradient">
      <Container>
        <Title level={2} css={title}>
          What makes us different
        </Title>
        <Row justify="center" align="top" css={row}>
          <Col md={8} xs={24} css={col}>
            <Paragraph>
              <div css={icon}>
                <svg id="icon-refund" viewBox="0 0 512 512">
                  <path d="m250 197c15 0 28 9 28 19 0 10-13 19-28 19-16 0-29-9-29-19 0-10 13-19 29-19z m-28 42c7 5 17 8 28 8 10 0 20-3 28-8 8-6 13-14 13-23 0-9-5-17-13-23-8-5-18-8-28-8-11 0-21 3-28 8-9 6-13 14-13 23 0 9 4 17 13 23z m-123-96c32-46 81-75 137-82 56-6 113 13 156 51l9 8c1 2 4 2 6 1 3-1 4-3 4-5 0-4 0-7 0-10 0-6 0-11 0-17 1-6 5-10 10-10 6 1 10 5 10 11 0 26 0 52 0 76 0 6-3 10-9 10-26 0-52 0-79 0-5 0-8-5-8-9-1-6 3-10 8-11 2 0 5 0 8 0 0 0 1 0 2 0 8 0 17 0 26 0 3 0 7 0 11 0 3 0 5-2 6-4 1-2 0-5-1-7-1-1-2-2-3-3-2-2-3-3-4-5-25-26-56-44-91-52-34-8-70-5-103 8-33 13-61 36-81 65-20 30-30 65-30 101 1 19 4 38 10 56 7 18 16 34 27 49 24 30 57 52 94 61 37 10 76 7 112-7 35-15 65-40 84-73 11-19 18-40 22-62 2-9 5-11 9-11 4-1 6 0 8 2 3 3 4 7 3 13-17 104-114 177-218 163-69-9-127-52-154-115-28-64-21-136 19-192z m52 40l12-7c4-1 7-3 10-4 9-5 18-9 26-13 1-1 2-1 3 0 22 9 44 18 66 27 37 15 76 31 114 47 0 0 0 0 0 0 0 0-1 0-1 1-7 4-13 9-20 13-1 0-2 1-2 2-5 3-9 5-13 8-14 9-27 18-41 28-1 0-1 0-3 0-50-24-102-48-151-72l-31-14 0-1c-1 0-1 0-1 0 11-5 21-10 32-15z m217 79c6 4 11 6 14 7 0 0 0 0 0 0 0 1-1 1-1 1-12 8-25 17-37 25-13 8-26 17-39 26-1 1-1 1-2 0-50-23-100-47-148-70l-35-16-1 0c0 0 0 0 0 0 2-2 5-3 8-5 4-3 10-6 13-8l5 3c50 23 101 47 152 71 2 1 4 2 7 2 2 0 5-1 8-3 13-9 27-18 41-27 3-3 7-5 11-8 1 1 2 1 4 2z m-1 40c7 3 12 6 15 7 0 0 0 0 0 0 0 0-1 0-1 0-12 9-25 17-37 25-13 9-26 18-39 26-1 1-2 1-2 1-50-24-100-47-149-70l-34-17-1 0c0 0 0 0 0 0 2-1 5-3 8-5 5-3 11-7 14-8 1 0 2-1 2-1l6 3c49 22 99 46 148 70 2 1 4 1 7 1 2 0 5-1 8-3 13-8 26-17 39-26 3-2 7-4 10-7 2 1 4 2 6 4z m-135 161c9 1 18 1 27 1 45 0 88-14 124-41 44-33 73-80 81-134 2-10 0-18-6-24-4-5-11-7-18-6-8 1-18 6-20 22-4 20-11 40-21 58-37 62-111 93-181 74-71-18-121-82-122-154 0-21 3-41 10-60 0 5 3 8 8 10 0 1 0 1 0 1l12 6c-2 1-4 2-6 3-3 2-6 4-8 5-4 2-6 6-6 10 0 4 2 8 6 11 1 0 1 1 2 1l15 7c-2 2-6 4-9 6-3 2-6 4-8 5-4 2-6 5-6 10 0 4 2 8 6 10 0 1 1 1 2 1l35 17c49 23 99 47 148 70 2 1 4 1 6 1 3 0 6 0 9-2 13-9 26-18 39-26 12-8 25-17 37-25 2-1 3-3 4-4 0 0 1-1 1-1 1-1 2-3 2-5l0-3c0-1 0-2 0-3-2-3-5-6-9-7-2-1-8-4-13-7 0 0 0 0 0 0 5-3 10-6 15-10 2-1 3-2 4-3 1-1 1-1 1-2 2-1 2-2 2-4l0-3c0-1 0-2 0-3-2-4-5-6-9-8-2 0-6-3-10-5 4-2 8-5 12-8 2-1 3-2 4-4 1 0 1 0 1-1 2-1 2-3 2-4l0-4c0-1 0-3-2-4 0 0 0-1-1-1-1-2-3-3-5-4-38-16-77-32-114-47-22-10-44-19-66-28-5-2-9-1-13 1-9 4-18 8-26 12-4 2-7 4-10 5l-13 7c-11 5-21 10-32 15-1 1-2 2-3 2 17-38 48-69 88-85 62-24 132-9 178 39-8 0-16 0-23 0-1 0-2 0-2 0-3 0-7 0-10 1-11 2-19 12-19 23 1 12 10 21 21 21 27 1 53 1 79 0 13 0 22-9 22-22 0-24 0-50 0-76 0-13-10-23-22-23-12-1-23 9-23 22-1 4-1 8-1 12-22-20-49-35-77-44-28-8-57-11-87-8-28 3-56 12-80 27-26 15-48 35-65 60-43 60-51 136-21 204 30 67 91 113 164 123z m66-199c2 0 3 0 4-1l32-22c3-1 4-5 2-8-2-3-6-4-9-2l-32 21c-3 2-4 6-2 9 1 2 3 3 5 3z m-120-55c1 0 3-1 4-1l31-23c3-2 4-6 2-9-2-2-6-3-9-1l-32 22c-2 2-3 6-1 9 1 2 3 3 5 3z"></path>
                </svg>
              </div>
            </Paragraph>
            <Title level={3} css={benefit}>
              Book with confidence
            </Title>
            <Paragraph css={detail}>
              Quotes are instant and reserved online. Cancellations up to 24 hours before pickup are
              refunded in full.
            </Paragraph>
          </Col>
          <Col md={8} xs={24} css={col}>
            <Paragraph>
              <div css={icon}>
                <svg id="icon-phone-chat" viewBox="0 0 512 512">
                  <path d="m128 330l-12 0 0-218c0-16 14-29 32-29l141 0c17 0 32 13 32 29l0 26-12 0 0-26c0-9-9-16-20-16l-141 0c-11 0-20 7-20 16z m161 99l-141 0c-18 0-32-13-32-29l0-70 12 0 0 70c0 9 9 16 20 16l141 0c11 0 20-7 20-16l0-70 12 0 0 70c0 16-15 29-32 29z m-140-49l165 0 0 12-165 0z m50-265l45 0 0 13-45 0z m44 249c-1 0-2 0-3-1-2-1-4-3-4-5l0-38-16 0c-17 0-31-14-31-32l0-108c0-18 14-32 31-32l144 0c18 0 32 14 32 32l0 108c0 18-14 32-32 32l-75 0-42 42c-1 1-3 2-4 2z m-23-204c-10 0-19 9-19 20l0 108c0 11 9 19 19 19l23 0c3 0 6 3 6 6l0 30 33-34c1-1 3-2 5-2l77 0c11 0 19-8 19-19l0-108c0-11-8-20-19-20z m24 82c0 0 0 0-1 0 0 0-1 0-1-1 0 0-1 0-1 0 0 0-1-1-1-1-1-1-2-3-2-4 0-1 0-1 0-1 1-1 1-1 1-2 0 0 0 0 0-1 1 0 1 0 1-1 0 0 1 0 1 0 0-1 1-1 1-1 0 0 1 0 1 0 2-1 4 0 6 1 1 2 2 3 2 5 0 1-1 3-2 4-1 1-3 2-5 2z m48-2c-1 0-3 0-4-1-1-2-2-3-2-5 0-1 1-3 2-4 2-2 6-2 9 0 1 1 1 3 1 4 0 2 0 3-1 5-2 1-3 1-5 1z m48 0c-2 0-3 0-4-1-1-1-1-1-1-1 0-1-1-1-1-1 0-1 0-1 0-2 0 0 0 0 0-1 0-1 0-3 2-4 2-2 6-2 8 0 1 1 2 3 2 4 0 1 0 1 0 1 0 1 0 1 0 2 0 0-1 0-1 1 0 0 0 0-1 1 0 0 0 0-1 0 0 1 0 1-1 1 0 0 0 0-1 0 0 0-1 0-1 0z" />
                </svg>
              </div>
            </Paragraph>
            <Title level={3} css={benefit}>
              Stay in control
            </Title>
            <Paragraph css={detail}>
              Our drivers are vaccinated and professional. Our operations team is on call over
              Whatsapp or phone.
            </Paragraph>
          </Col>
          <Col md={8} xs={24} css={col}>
            <Paragraph>
              <div css={icon}>
                <svg id="icon-air-conditioner" viewBox="0 0 512 512">
                  <path d="m334 420c0 0-35 5-78 5-43 0-78-5-78-5 0 0 35-4 78-4 43 0 78 4 78 4z m72-333l-300 0c-9 0-17 9-17 19l0 66c0 8 2 14 6 20 5 9 15 15 25 15l272 0c10 0 20-6 25-15 4-6 6-12 6-20l0-66c0-10-8-19-17-19z m7 85c0 6-2 11-4 15-4 6-11 10-17 10l-272 0c-6 0-13-4-17-10-2-4-4-9-4-15l0-66c0-4 3-8 7-8l300 0c4 0 7 4 7 8z m-30-3l16 0c2 0 5-2 5-5 0-3-3-5-5-5l-16 0c-3 0-5 2-5 5 0 3 2 5 5 5z m18 6l-291 0c-2 0-3 2-3 3 0 7 5 12 12 12l273 0c7 0 12-5 12-12 0-1-1-3-3-3z m-60 67c0-3-2-5-5-5-3 0-5 2-5 5 0 5-2 7-4 10-2 3-5 7-5 15 0 8 3 13 5 16 2 3 4 5 4 10 0 5-2 7-4 10-2 3-5 7-5 15 0 3 2 5 5 5 3 0 5-2 5-5 0-5 1-7 3-10 3-3 6-7 6-15 0-8-3-12-6-16-2-3-3-5-3-10 0-4 1-6 3-9 3-4 6-8 6-16z m-50 0c0-3-3-5-5-5-3 0-5 2-5 5 0 5-2 7-4 10-3 3-6 7-6 15 0 8 3 13 6 16 2 3 4 5 4 10 0 5-2 7-4 10-3 3-6 7-6 15 0 3 3 5 6 5 2 0 5-2 5-5 0-5 1-7 3-10 3-3 6-7 6-15 0-8-3-12-6-16-2-3-3-5-3-10 0-4 1-6 3-9 3-4 6-8 6-16z m-50 0c0-3-3-5-6-5-2 0-5 2-5 5 0 5-1 7-3 10-3 3-6 7-6 15 0 8 3 13 6 16 2 3 3 5 3 10 0 5-1 7-3 10-3 3-6 7-6 15 0 3 3 5 5 5 3 0 5-2 5-5 0-5 2-7 4-10 3-3 6-7 6-15 0-8-3-12-6-16-2-3-4-5-4-10 0-4 2-6 4-9 3-4 6-8 6-16z m-51 0c0-3-2-5-5-5-3 0-5 2-5 5 0 5-1 7-3 10-3 3-6 7-6 15 0 8 3 13 6 16 2 3 3 5 3 10 0 5-1 7-3 10-3 3-6 7-6 15 0 3 2 5 5 5 3 0 5-2 5-5 0-5 2-7 4-10 2-3 5-7 5-15 0-8-3-12-5-16-2-3-4-5-4-10 0-4 2-6 4-9 2-4 5-8 5-16z"></path>
                </svg>
              </div>
            </Paragraph>
            <Title level={3} css={benefit}>
              Travel in comfort
            </Title>
            <Paragraph css={detail}>
              Every vehicle is air-conditioned. We arrange 4G mobile hotspots, child safety seats,
              and local tour guides upon request.
            </Paragraph>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
export default Benefits
